import Button from "@app/components/move2Library/Button/Button"
import MyParadiseAddressModal from "@app/modals/MyParadise/MyParadiseAddressModal/MyParadiseAddressModal"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetCountries, useGetSalutations } from "@app/store/service/connectorService"
import { useModal } from "@tecreation/funnel-components"
import "./AddressEntry.css"

export const AddressEntry = ({ address, editable, openModalAfterUpdate, className, onClick, selected }) => {
	const { data: salutations } = useGetSalutations(undefined, { defaultData: [] })
	const { data: countries } = useGetCountries(undefined, { defaultData: [] })
	const {
		data: { address: addressString, buttonEdit },
	} = useGetStrings()

	const salutation = salutations.find(e => e.salutationId == address.genderId)
	const country = countries.find(e => e.countryId == address.countryId)
	const buttonAria = addressString + address.address + (address.houseNo ?? "")

	const modal = useModal()

	return (
		<button className={"addressButton border color-border-primary rounded-3 w-100 p-3 mb-3 " + className} onClick={onClick} aria-pressed={selected}>
			<div role="group" aria-label={buttonAria} className="flex-items-center flex-md">
				<div className="flex-1">
					{!address.companyName ? (
						<div className="bold mb-1">
							{salutation?.translation || salutation?.salutation} {address.firstName} {address.lastName}
						</div>
					) : (
						<div className="bold mb-1">{address.companyName}</div>
					)}
					{address.companyName && (
						<div className="mb-1">
							{salutation?.translation || salutation?.salutation} {address.firstName} {address.lastName}
						</div>
					)}
					<div className="mb-1">{address.addressAddition}</div>
					<div className="mb-1">
						{address.address} {address.houseNo}
					</div>
					<div className="mb-1">
						{address.zipCode}, {address.city}
					</div>
					<div className="mb-1">{address.email}</div>
					<div className="mb-1">{country?.country}</div>
				</div>
				{editable && (
					<div>
						<Button fillWidth style="filled" className="primary" onClick={() => modal.showModal(MyParadiseAddressModal, { address, openModalAfterUpdate })}>
							<div className="medium">{buttonEdit}</div>
						</Button>
					</div>
				)}
			</div>
		</button>
	)
}
